const state = {
	myProfile: null
};

const getters = {
	getMyProfile: (state) => state.myProfile
};

const mutations = {
	updMyProfile(state, payload) {
		state.myProfile = payload;
	}
};

const actions = {
	setMyProfile({ commit }, profile) {
		commit('updMyProfile', profile);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
